import React from "react";
import Navbar from "../Components/Navbar";
import HalfHero from "../Images/main.jpg";
import Blog from "../Components/Blog";

const Blogs = () => {
  return (
    <div>
      <section className="relative w-full h-1/2 overflow-hidden">
        {/* Background Image (with blur) */}
        <img
          src={HalfHero}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover z-[-10] blur-sm"
        />

        {/* Navbar */}
        <Navbar />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70 z-[-5]" />
      </section>
      <section className="flex justify-center items-center h-full">
        <Blog />
      </section>
    </div>
  );
};

export default Blogs;
